@use "@fukuri-admins/ui/layout" as *;

.container {
  background-color: background('Sky');
  border-radius: borderRadius('md');
  padding: spacing('12') spacing('16');
  display: flex;
  align-items: center;
  gap: spacing('8');
}

.containerSet {
  background-color: background('Senary');
  border-radius: borderRadius('md');
  padding: spacing('12') spacing('16');
  display: flex;
  align-items: center;
  gap: spacing('8');
}

.body {
  flex: 1;
  display: flex;
  align-items: flex-start;
  gap: spacing('8');
}

.textGroup {
  display: flex;
  flex-direction: column;
  gap: spacing('4');
}

.titleRow {
  display: flex;
  align-items: center;
  gap: spacing('8');
}

.title {
  @include typography('Jp/14_W6');
  color: text('High');
}

.description {
  @include typography('Jp/14_W3');
  color: text('Low');
}

.clockIcon {
  color: text('Middle');
}

.icon {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  color: text('Link');
  svg {
    color: currentColor;
  }
}

.actions {
  display: flex;
  gap: spacing('8');
  flex-shrink: 0;
}
